// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Vhoo","notes":"Notes_notes__-yYB4"};